const categories = [
    {
      name: 'all',
      text: '전체',
    },
    {
      name: 'mouth',
      text: '입호흡',
    },
    {
      name: 'lung',
      text: '폐호흡',
    },
    {
      name: 'device',
      text: '기기',
    }
];

export default categories;